<template>
  <div>
    <Breadcrumb />

    <SearchHelpcenter />

    <v-layout row wrap class="mt-4 px-1">
      <v-flex xs12 md12>
        <p class="title mt-2 hc__blue-text">Preguntas frecuentes</p>
      </v-flex>

      <v-flex xs12 md9>
        <ListImportantQuestions :questions="questions" />
      </v-flex>

      <v-flex xs12 md3 :class="{ 'pl-2': !isMobile }">
        <CardInfoTicketA />
      </v-flex>

      <v-flex xs12 md12 mt-4>
        <p class="title hc__blue-text">
          Elige la categoría para la que necesitas resolver dudas
        </p>
      </v-flex>
      
      <v-flex xs12 md9>
        <CategoryList :categories="categories" />
      </v-flex>
      
    </v-layout>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Breadcrumb from "@/components/General/Breadcrumb";
import SearchHelpcenter from "@/components/Helpcenter/SearchHelpcenter";
import ListImportantQuestions from "@/components/Helpcenter/ListImportantQuestions.vue";
import CategoryList from "@/components/Helpcenter/CategoryList.vue";
import CardInfoTicketA from "@/components/Helpcenter/CardInfoTicketA";

export default {
  components: {
    Breadcrumb,
    SearchHelpcenter,
    ListImportantQuestions,
    CategoryList,
    CardInfoTicketA,
  },
  data() {
    return {
      questions: [],
      categories: [],
    };
  },
  methods: {
    ...mapActions("helpcenter", ["fetchCategories", "fetchQuestionsImportant"]),
    async getImportantQuestions() {
      const res = await this.fetchQuestionsImportant();
      this.questions = res;
    },
    async getCategories() {
      const res = await this.fetchCategories();
      let filter_categories = res.filter(category => category.hide_category == false);
      this.categories = filter_categories;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.getImportantQuestions();
    this.getCategories();
  },
};
</script>
<style lang="css">
.hc__rounded-card {
  border-radius: 0.5rem;
}

.hc__blue-text {
  color: #28385C;
}

.hc__color-2 {
  color: #28385C !important;
}
</style>
